import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { exportTaxonomyRecommendation, ExportTaxonomyRecommendationApiParameter } from "@tCentro/Services/CENTaxonomyExportService";


type HandlerType = Handler<
    {},
    {
        apiParameter: ExportTaxonomyRecommendationApiParameter;
        apiResult: Blob;
    }
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {

    };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await exportTaxonomyRecommendation(props.apiParameter);
};

export const DownloadFile: HandlerType = async props => {
    if (!props.apiResult) {
        return;
    }

    // Create blob with proper Excel MIME type
    const excelBlob = new Blob([props.apiResult], { 
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
    });

    const fileName = `taxonomy_recommendation_export_${new Date().toISOString().split('T')[0]}.xlsx`;
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(excelBlob);
    downloadLink.setAttribute("download", fileName);
    downloadLink.click();
    
    // Cleanup
    window.URL.revokeObjectURL(downloadLink.href);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DownloadFile];

const exportTaxonomyRecommendationHandler = createHandlerChainRunner(chain, "ExportTaxonomyRecommendation");
export default exportTaxonomyRecommendationHandler;